import React from 'react'
import { FiDollarSign, FiPackage, FiUserCheck, FiHeadphones } from 'react-icons/fi'

const driverBenefits = [
    {
        icon: <FiDollarSign className="text-primary text-4xl mb-4" />,
        title: 'Earn More, On Your Schedule',
        description: 'Work when it suits you and get paid for every successful delivery.',
    },
    {
        icon: <FiPackage className="text-primary text-4xl mb-4" />,
        title: 'No Passengers, No Small Parcels',
        description: 'Just straight commercial deliveries to keep businesses running.',
    },
    {
        icon: <FiUserCheck className="text-4xl mb-4" />,
        title: 'Be Your Own Boss',
        description: 'Accept the jobs you want, reject the ones you don’t.',
    },
    {
        icon: <FiHeadphones className="text-primary text-4xl mb-4" />,
        title: 'Support When You Need It',
        description: 'Our driver support team is available to help you anytime.',
    },
]

const WhyDriveWithUs = () => {
    return (
        <section className='px-4 py-10 md:py-20 bg-white'>
            <div className='max-w-7xl w-full mx-auto'>
                <div>
                    <span className="text-primary font-bold mb-2 uppercase text-base md:text-lg block text-center">Freedom</span>
                    <h1 className="text-3xl md:text-4xl font-bold text-headings text-center">
                        Why Drive with Tuber?
                    </h1>
                </div>

                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 bg-white overflow-hidden mt-10'>
                    {driverBenefits.map((benefit, index) => (
                        <div
                            key={index}
                            className={`p-8 md:p-10 border border-gray-200 shadow-shadow-5 rounded-xl space-y-8 ${index === 2 ? 'bg-primary text-white' : 'bg-white text-black'
                                }`}
                        >
                            <span>{benefit.icon}</span>
                            <div>
                                <h2 className='text-xl font-bold mb-2'>{benefit.title}</h2>
                                <p className='text-base font-medium'>
                                    {benefit.description}
                                </p>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
        </section>
    )
}

export default WhyDriveWithUs
